//Fiat currencies
export const EURO_CURRENCY_CODE = 'EUR'
export const USD_CURRENCY_CODE = 'USD'

//Crypto currencies
export const USDT_CURRENCY_CODE = 'USDT'
